import { PWBHost } from "promise-worker-bi";

export class HostWorkerBase {
    protected worker: PWBHost;
    
}